import axiosInstance from '../api/axiosInstance';
// import { handleApiErrorAlert } from '../utils/alertHelpers'; // Kullanılacaksa import edilmeli

const paymentService = {
    /**
     * BIN numarası ile taksit seçeneklerini getirir
     * @param {Object} data - BIN ve fiyat bilgisi
     * @param {string} data.binNumber - Kart BIN numarası (ilk 6-8 hane)
     * @param {number} data.price - Toplam tutar
     * @returns {Promise<Object>} Taksit seçenekleri
     */
    getInstallmentOptions: async (data) => {
        try {
            // API'nin beklediği format için field mapping yap
            const requestData = {
                binNumber: data.binNumber,
                amount: data.price, // price -> amount field mapping
                currency: data.currency || 'TRY'
            };

            const apiAxiosResponse = await axiosInstance.post('/payment/bin-installments', requestData);
            const apiData = apiAxiosResponse.data;

            // Yeni API response formatına göre parse et
            if (apiData && apiData.success && apiData.installmentOptions && apiData.installmentOptions.length > 0) {
                // Başarıyla alındı ve geçerli taksit verisi var
                // API formatından frontend formatına çevir
                const installmentPrices = apiData.installmentOptions.map(option => ({
                    installmentNumber: option.installmentCount,
                    installmentPrice: option.installmentAmount,
                    totalPrice: option.totalAmount,
                    interestRate: option.interestRate,
                    isAvailable: option.isAvailable,
                    description: option.description
                }));

                console.log("BIN Details:", apiData.binDetails);
                console.log("Installment Options:", installmentPrices);

                return {
                    succeeded: true,
                    installmentPrices: installmentPrices,
                    binDetails: apiData.binDetails,
                    message: "Taksit seçenekleri başarıyla alındı."
                };
            } else if (apiData && apiData.success) {
                // API başarılı yanıt verdi ancak geçerli taksit detayı yok
                return {
                    succeeded: true,
                    installmentPrices: [],
                    message: apiData.errorMessage || "Bu kart için uygun taksit seçeneği bulunamadı.",
                };
            } else {
                // API bir hata raporluyor
                console.error("Taksit seçenekleri alınamadı (API hatası):", apiData);
                return {
                    succeeded: false,
                    message: apiData?.errorMessage || "Taksit seçenekleri API'den alınamadı.",
                    installmentPrices: [],
                };
            }
        } catch (error) {
            console.error("Taksit seçenekleri alınamadı (network error):", error.response?.data || error.message);
            return {
                succeeded: false,
                message: error.response?.data?.message || error.response?.data?.errorMessage || "Taksit seçenekleri yüklenirken bir sunucu/ağ hatası oluştu.",
                installmentPrices: [],
            };
        }
    },

    /**
     * PayTR ile 3DS ödeme başlatma isteği gönderir.
     * @param {Object} paymentInitializeRequest - Backend PayTRInitializePaymentRequestDto'suna karşılık gelen veri.
     * @returns {Promise<Object>} Backend PayTRInitializePaymentResponseDto'suna karşılık gelen veri.
     */
    initializePayTRPayment: async (paymentInitializeRequest) => {
        try {
            const response = await axiosInstance.post('/payment/initialize-paytr', paymentInitializeRequest);
            return response.data; 
        } catch (error) {
            console.error('PayTR ödeme başlatma hatası:', error.response?.data || error.message);
            return error.response?.data || { 
                status: 'failure', 
                success: false,    
                message: 'Ödeme başlatılırken bir sorun oluştu.',
                errorCode: null,
            };
        }
    },

    /**
     * PayTR ile ödeme iadesi yapar.
     * @param {Object} refundRequest - PayTRRefundRequestDto'suna karşılık gelen veri.
     * @returns {Promise<Object>} PayTRRefundResponseDto'suna karşılık gelen veri.
     */
    refundPayTRPayment: async (refundRequest) => {
        try {
            const response = await axiosInstance.post('/payment/refund', refundRequest);
            return response.data;
        } catch (error) {
            console.error('PayTR iade hatası:', error.response?.data || error.message);
            return error.response?.data || {
                status: 'failure', 
                success: false,    
                message: 'İade işlemi sırasında bir sorun oluştu.',
                errorCode: null,
            };
        }
    }
};

export default paymentService; 